import React from "react";
import clsx from "clsx";

export default function PSPage({
  children, 
  header,
  collapseBottom
}) {
  return (
    <>
      <div className={clsx(
        "relative",
        collapseBottom ? "" : "pb-[70px]"
      )}>
        {header && (
          <PSPageHeader 
            title={header} />
        )}

        <div className="w-main py-3">
          {children}
        </div>
      </div>
    </>
  );
};

export function PSPageHeader({ title, publicProfileLink, logoutLink }) {
  
  return (
    <div className="w-full bg-secondary mb-6">
      <div className="w-main flex items-center py-2">
        <h1 
          className="
             
            tracking-[.5px] 
            text-[17px] 
            uppercase 
            grow
          "
        >{title}</h1>
      </div>
    </div>
  );
}